import { Dialog, MenuItem } from "@mui/material";
import Button from "components/common/Button";
import Input from "components/common/Input";
import Select from "components/common/Select";
import api from "config/api";
import { table } from "console";
import { format } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";

type Props = {};

const timeOptions = [
  "5m",
  "15m",
  "25m",
  "35m",
  "45m",
  "55m",
  "1h 5m",
  "1h 15m",
  "1h 25m",
  "1h 35m",
  "1h 45m",
  "2h",
];

const initialData = {
  date: format(new Date(), "yyyy-MM-dd"),
  time: format(new Date(), "HH:mm"),
  timeForTable: "1h",

  firstName: "",
  lastName: "",
  phoneNo: "",
  email: "",
};

const ReservationDialog = (props: Props) => {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>(initialData);
  const [showDialog, setShowDialog] = useState(false);
  const [tableGroupList, setTableGroupList] = useState([]);
  const [selectedTableGroup, setSelectedTableGroup] = useState(null);
  const [tableList, setTableList] = useState([]);

  useEffect(() => {
    api
      .get("/api/Table/TableGroup")
      .then(({ data }) => {
        setTableGroupList(data);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (selectedTableGroup) {
      api
        .get(`/api/Table/TableByGroup?groupId=${selectedTableGroup}`)
        .then(({ data }) => {
          setTableList(data);
        })
        .catch(() => {});
    }
  }, [selectedTableGroup]);

  const onClose = () => {
    setShowDialog(false);
  };

  const finalDateTime = useMemo(() => {
    const time = new Date(data.date);
    time.setHours(data.time.split(":")[0]);
    time.setMinutes(data.time.split(":")[1]);

    return format(time, "MM/dd/yyyy h:mm:ss a");
  }, [data]);

  const onSubmit = async () => {
    if (
      !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        data.email
      )
    ) {
      toast.error("Invalid Email");
      return;
    }
    if (!data.firstName || !data.lastName) {
      toast.error("First Name & Last Name are required");
      return;
    }

    if (!/^\d{10}$/.test(data.phoneNo)) {
      toast.error("Invalid Phone Number");
      return;
    }
    setLoading(true);
    const userResponse = await api
      .get(`/api/Customer/ByPhone?phoneNo=${data.phoneNo}`)
      .then(({ data }) => data)
      .catch(async () => {
        return (await api.post(`api/Customer`, { ...data, password: "123" }))
          .data;
      });
    const finalPayload = {
      id: 0,
      tableid: data.tableid,
      custid: userResponse.clientId,
      custname: `${data.firstName} ${data.lastName}`,
      guests: 0,
      status: "",
      adults: 0,
      child: 0,
      handicap: 0,
      date: data.date,
      time: data.time,
      telephone: data.phoneNo,
      posid: 0,
      userid: 0,
      online: 0,
      deleted: "",
      enable: "",
      note: data.note,
    };

    api
      .post(`/api/Reservation/AddReservation`, finalPayload)
      .then(({ data }) => {
        toast.success("Reservation Created Successfully");
        onClose();
      })
      .catch(() => toast.error("Something went wrong"))
      .finally(() => setLoading(false));
  };
  return (
    <div>
      <Button
        onClick={() => setShowDialog(!showDialog)}
        className="bg-white !text-dark-text !px-1 sm:!px-2 !py-2 relative"
      >
        Reservation
      </Button>
      <Dialog onClose={onClose} open={showDialog} maxWidth="lg">
        <div className="md:min-w-[600px] p-6 flex flex-col gap-3">
          <h4 className="!text-lg text-primary font-semibold text-center pb-1 border-b">
            Online Reservation
          </h4>
          <div className="flex flex-col gap-3">
            {step === 0 && (
              <>
                <Input
                  size="small"
                  type="date"
                  label="Date"
                  value={data.date}
                  onValueChange={(date) =>
                    setData((e: any) => ({ ...e, date }))
                  }
                />
                <Input
                  size="small"
                  type="time"
                  label="Time"
                  value={data.time}
                  onValueChange={(time) =>
                    setData((e: any) => ({ ...e, time }))
                  }
                />
                <Select
                  size="small"
                  label="Time for Table"
                  value={data.timeForTable}
                  onValueChange={(timeForTable) =>
                    setData((e: any) => ({ ...e, timeForTable }))
                  }
                >
                  {timeOptions.map((item) => (
                    <MenuItem value={item}>{item}</MenuItem>
                  ))}
                </Select>
                <div className="flex gap-3">
                  <Button className="flex-1" onClick={onClose}>
                    Cancel
                  </Button>
                  <Button
                    className="flex-1"
                    onClick={() => setStep((e) => e + 1)}
                  >
                    Reservation Now
                  </Button>
                </div>
              </>
            )}
            {step === 1 && (
              <>
                <Input
                  size="small"
                  label="Date"
                  disabled
                  value={finalDateTime}
                  sx={{ flex: 1 }}
                />

                <div className="flex max-sm:flex-col gap-3">
                  <Input
                    size="small"
                    label="First Name"
                    value={data.firstName}
                    sx={{ flex: 1 }}
                    onValueChange={(firstName) =>
                      setData((e: any) => ({ ...e, firstName }))
                    }
                  />

                  <Input
                    size="small"
                    label="Last Name"
                    value={data.lastName}
                    sx={{ flex: 1 }}
                    onValueChange={(lastName) =>
                      setData((e: any) => ({ ...e, lastName }))
                    }
                  />
                </div>
                <div className="flex max-sm:flex-col gap-3">
                  <Input
                    size="small"
                    label="Email"
                    value={data.email}
                    sx={{ flex: 1 }}
                    onValueChange={(email) =>
                      setData((e: any) => ({ ...e, email }))
                    }
                  />
                  <Input
                    size="small"
                    label="Phone Number"
                    value={data.phoneNo}
                    sx={{ flex: 1 }}
                    onValueChange={(phoneNo) =>
                      setData((e: any) => ({ ...e, phoneNo }))
                    }
                  />
                </div>
                <Input
                  size="small"
                  type="number"
                  label="Total Count"
                  value={data.totalCount}
                  sx={{ flex: 1 }}
                  onValueChange={(totalCount) =>
                    setData((e: any) => ({ ...e, totalCount }))
                  }
                />
                <div className="flex max-sm:flex-col gap-3">
                  <Select
                    size="small"
                    label="Table Options"
                    value={selectedTableGroup}
                    onValueChange={(e) => setSelectedTableGroup(e)}
                  >
                    {tableGroupList.map((item: any) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                  <Select
                    size="small"
                    label="Table"
                    value={data.tableid}
                    onValueChange={(tableid) =>
                      setData((e: any) => ({ ...e, tableid }))
                    }
                  >
                    {tableList.map((item: any) => (
                      <MenuItem value={item.id}>{item.name}</MenuItem>
                    ))}
                  </Select>
                </div>
                <Input
                  size="small"
                  label="Note"
                  value={data.note}
                  sx={{ flex: 1 }}
                  onValueChange={(note) =>
                    setData((e: any) => ({ ...e, note }))
                  }
                />
                <div className="flex gap-3">
                  <Button
                    className="flex-1"
                    onClick={() => setStep((e) => e - 1)}
                  >
                    Back
                  </Button>
                  <Button
                    disabled={loading}
                    className="flex-1"
                    onClick={onSubmit}
                  >
                    Complete Reservation
                  </Button>
                </div>
              </>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ReservationDialog;
